import { FC } from "react";
import { Abonnement } from "../../lib/interfaces/abonnement.interface";
import { formatDate } from "../../lib/helpers/date_helpers";
import clsx from "clsx";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { Download, MoreVertical } from "lucide-react";
import { Button } from "../ui/button";

interface Props {
  abo: Abonnement;
}

const AbonnementItem: FC<Props> = ({ abo }) => {
  const hasRevue = abo.revue || abo.revueNumerique;

  return (
    <article className='relative pl-6 before:absolute before:bottom-[-1.5rem] before:left-[5px] before:top-4 before:w-px before:bg-slate-200 last:before:hidden'>
      <span className='absolute left-0 top-1.5 h-[11px] w-[11px] rounded-full border-[3px] border-[#d4ad3d] bg-white' />
      <div className='flex items-start justify-between gap-3'>
        <div className='min-w-0'>
          <div className='font-semibold text-slate-900'>
            Du {formatDate(abo.dateDebut)} au {formatDate(abo.dateFin)}
          </div>
          <div className='mt-2 flex flex-wrap gap-2'>
            <div
              className={clsx("rounded-full px-2.5 py-1 text-xs font-medium", {
                "bg-emerald-50 text-emerald-800": hasRevue,
                "bg-slate-100 text-slate-600": !hasRevue,
              })}
            >
              Revue {hasRevue ? (abo.revue ? "papier" : "numérique") : "non incluse"}
            </div>
            <div
              className={clsx("rounded-full px-2.5 py-1 text-xs font-medium", {
                "bg-[#fff6d8] text-[#725716]": abo.citeo,
                "bg-slate-100 text-slate-600": !abo.citeo,
              })}
            >
              {abo.citeo
                ? `Éco-contribution · ${abo.ruches} ruche${abo.ruches === 1 ? "" : "s"}`
                : "Éco-contribution non incluse"}
            </div>
          </div>
        </div>
        {abo.citeo && (
          <div>
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button
                  aria-label="Ouvrir les documents de l'éco-contribution"
                  className='-mr-2 shrink-0 text-slate-500 hover:bg-[#fff8df] hover:text-[#705616]'
                  variant={"ghost"}
                  size={"icon"}
                >
                  <MoreVertical className="h-5 w-5" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent>
                <DropdownMenuLabel>Eco-contribution</DropdownMenuLabel>
                <DropdownMenuSeparator />
                <DropdownMenuItem
                  onClick={() => {
                    window.open("https://pdf.labeilledefrance.com/kits/kit-info-tri.zip", "_blank");
                  }}
                >
                  <Download className='w-4 h-4 text-gray-700 mr-4' />
                  Kit info-tri
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        )}
      </div>
    </article>
  );
};

export default AbonnementItem;
